import {
  HelpdeskClientContext,
  HelpdeskDeviceInfo,
  HelpdeskDeviceType,
} from '@ups/xplat/base/in-app-help';
import { parseUserAgent } from '@ups/xplat/utils/user-agent';

/** The form fields the HaloITSM modal collects (a subset of its HALOHelpDesk model). */
export interface HaloTicketFormValues {
  summary?: string;
  detailsHTML?: string;
  category?: string;
  impact?: string;
  urgency?: string;
  ticketType?: string;
  smartlookURL?: string;
}

/** The POST api/Helpdesk/createTicket body (CreateHelpdeskTicketDTO). */
export interface HaloTicketPayload {
  title?: string;
  description?: string;
  category?: string;
  impact?: string;
  urgency?: string;
  ticketType?: string;
  smartlookURL?: string;
  clientContext: HelpdeskClientContext;
}

/**
 * US 34308: phone / tablet / computer plus browser and OS from the browser itself.
 * iPadOS Safari reports a Mac user agent by default, so touch points are the tablet tell.
 */
export function webHelpdeskDevice(
  userAgent: string | null | undefined,
  maxTouchPoints: number
): HelpdeskDeviceInfo {
  const ua = userAgent ?? '';
  const parsed = parseUserAgent(ua);
  const info: HelpdeskDeviceInfo = {
    deviceType: webDeviceType(ua, maxTouchPoints),
  };
  if (parsed && parsed.browserFamily !== 'other') {
    info.browser = parsed.browserLabel;
  }
  if (parsed && parsed.osLabel !== 'Unknown') {
    info.os = parsed.osLabel;
  }
  return info;
}

export function buildHaloTicketPayload(
  form: HaloTicketFormValues,
  clientContext: HelpdeskClientContext
): HaloTicketPayload {
  return {
    title: form.summary,
    description: form.detailsHTML,
    category: form.category,
    impact: form.impact,
    urgency: form.urgency,
    ticketType: form.ticketType,
    // Same field the modal stamps from sessionUrl(); must reach Halo or the
    // ticket loses the load-bearing session deep link (#30073 / ticket parity).
    smartlookURL: form.smartlookURL,
    clientContext,
  };
}

function webDeviceType(ua: string, maxTouchPoints: number): HelpdeskDeviceType {
  if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) {
    return 'tablet';
  }
  if (/Macintosh/i.test(ua) && maxTouchPoints > 1) {
    return 'tablet';
  }
  if (/Mobi|iPhone|iPod|Android/i.test(ua)) {
    return 'phone';
  }
  return 'computer';
}
